import urls from '../api_urls/message'
import { _post } from '@/axios/request'
// 获取消息列表
export function getTableData (params) {
    return _post(urls.GET_LIST, params)
}

// 发送消息
export function sendMessageApi (params) {
    return _post(urls.SEND_MESSAGE, params)
}

// 获取消息详情
export function getDetail (params) {
    return _post(urls.GET_DETAIL, params)
}

// 获取消息列表
export function getReceivedTableData (params) {
    return _post(urls.GET_RECEIVED_LIST, params)
}


// WEBPACK FOOTER //
// ./src/axios/api/message.js